import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FiArrowRight } from "@/lib/icons";

interface CTASectionProps {
  label?: string;
  title: string;
  description?: string;
  primaryAction?: {
    label: string;
    href: string;
  };
  secondaryAction?: {
    label: string;
    href: string;
  };
}

/**
 * CTA section - matches me&u dark style
 */
export function CTASection({
  label,
  title,
  description,
  primaryAction = { label: "Get Started", href: "/contact" },
  secondaryAction,
}: CTASectionProps) {
  return (
    <section className="px-4 py-4">
      <div className="bg-primary rounded-[2.5rem] py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-3xl mx-auto text-center">
          {label && <p className="section-label mb-4">{label}</p>}

          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-primary-foreground leading-tight">
            {title}
          </h2>

          {description && (
            <p className="mt-4 text-lg text-primary-foreground/90 max-w-xl mx-auto">
              {description}
            </p>
          )}

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              asChild
              size="lg"
              className="btn-pill bg-accent text-accent-foreground hover:bg-accent/90 px-8 h-12"
            >
              <Link to={primaryAction.href}>
                {primaryAction.label}
                <FiArrowRight className="ml-2 size-4" />
              </Link>
            </Button>

            {secondaryAction && (
              <Button
                asChild
                size="lg"
                className="btn-pill bg-white/10 border border-white/20 text-white hover:bg-white/20 px-6 h-12"
              >
                <Link to={secondaryAction.href}>{secondaryAction.label}</Link>
              </Button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
